module.exports = __webpack_public_path__ + "img/clock3-01.7b6f152d.png";